import { Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/system'
import React from 'react'
import CustomContainer from '../../../components/common/CustomContainer'
import { RouteConstants } from '../../../navigation/navigation-types'
import { SurveyResponseDto } from '../../../services/api/sharedTypes/Email'

interface SurveyDetailSelectionsProps {
    survey: SurveyResponseDto
}

const SurveyDetailSelections: React.FC<SurveyDetailSelectionsProps> = ({ survey }: SurveyDetailSelectionsProps) => {
    const theme = useTheme()

    return (
        <CustomContainer bgColor={theme.palette.background.default}>
            <Typography variant='h6'>Informace</Typography>
            <Stack direction='row' justifyContent='space-between'>
                <div>
                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography variant='body1' my={1} color={theme.palette.grey[700]}>
                            Událost:{' '}
                        </Typography>
                        <a href={RouteConstants.events + '/' + survey.eventIdName.id}>{survey.eventIdName.name}</a>
                    </Stack>
                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography variant='body1' my={1} color={theme.palette.grey[700]}>
                            Datum události:{' '}
                        </Typography>
                        <Typography variant='body2'>
                            {`${new Date(survey.eventStartsAt).toLocaleDateString('cs')} - ${new Date(
                                survey.eventEndsAt
                            ).toLocaleDateString('cs')}`}
                        </Typography>
                    </Stack>
                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography variant='body1' my={1} color={theme.palette.grey[700]}>
                            Adresa:{' '}
                        </Typography>
                        <Typography variant='body2'>
                            {survey.address.street + ', ' + survey.address.city + ', ' + survey.address.zip}
                        </Typography>
                    </Stack>
                </div>
                <div>
                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography variant='body1' my={1} color={theme.palette.grey[700]}>
                            Klient:{' '}
                        </Typography>
                        <Typography variant='body2'>{survey.respondentIdName.name}</Typography>
                    </Stack>

                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography variant='body1' my={1} color={theme.palette.grey[700]}>
                            Dotazník vytvořen:{' '}
                        </Typography>
                        <Typography variant='body2'>{new Date(survey.responseCreatedAt).toLocaleDateString('cs')}</Typography>
                    </Stack>
                </div>
            </Stack>
        </CustomContainer>
    )
}

export default SurveyDetailSelections
